import { Notify } from 'quasar'
import { getTenantFromHost } from 'src/shared/lib/tenant-from-host'
import { fetchTenantHint } from './api'

/**
 * Тенант страницы входа по её адресу (CUSTDOM D10):
 *   1. свой веб-домен тенанта — спрашиваем сервер (`callc.cardio-tomsk.ru` → `cardio`);
 *   2. поддомен базового домена платформы (`cardio.omniflow.ru` → `cardio`);
 *   3. `null` — тенант вводят руками.
 *
 * Один запрос на загрузку страницы: логин и модалка перелогина делят результат. Сбой подсказки
 * вход не блокирует — пользователь видит уведомление и ручное поле, а повторный вызов спросит
 * сервер заново.
 */
let pending: Promise<string | null> | null = null

const askServer = async (host: string): Promise<string | null> => {
  try {
    return await fetchTenantHint(host)
  } catch (err) {
    pending = null
    console.error('tenant-hint:', err)
    Notify.create({
      type: 'warning',
      message: 'Не удалось определить организацию по адресу страницы — укажите её вручную',
    })
    return null
  }
}

export const resolveHostTenant = (): Promise<string | null> => {
  if (!pending) {
    const host = location.hostname
    pending = askServer(host).then((hinted) => hinted ?? getTenantFromHost())
  }
  return pending
}

/** Только для тестов: сбросить кэш между сценариями. */
export const resetHostTenantCache = (): void => {
  pending = null
}
